import { FlexBox } from '@helloself/hello-self-ui';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';

const List = ({ children }: PropsWithChildren<unknown>) => (
    <FlexBox flexDirection={'column'} gap={'16px'}>
        {children}
    </FlexBox>
);

const StyledListItem = styled(FlexBox as any)`
    &:not(:first-child) {
        padding-top: 16px;
        border-top: 1px solid #e8e8e8;
    }
`;

const ListItem = ({ children }: PropsWithChildren<unknown>) => <StyledListItem>{children}</StyledListItem>;

List.Item = ListItem;

export default List;
